export const organization = {
  add: {
    label: "Add organization",
  },
  delete: {
    label: "Delete organization",
  },
  form: {
    name: { label: "Name" },
    description: { label: "Description" },
    address: { label: "Address" },
    image: { label: "Logo" },
    defaultTemplate: { label: "Default intervention template" },
  },
};
